// extracted by mini-css-extract-plugin
export default {"text":"MobileWallet_text__tvUAU","img":"MobileWallet_img__R5XVH","btnWrapper":"MobileWallet_btnWrapper__aEGaQ"};